import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axios";
import "../datatable/datatable.scss";
import { DataGrid } from "@mui/x-data-grid";

export const StudentResource = () => {
  const [studentId] = useState(Number(localStorage.getItem("studentId")));

  const [filters, setFilters] = useState({
    sessions: "",
    report_type: "",
  });

  const [allLinks, setAllLinks] = useState([]); // All data based on batch
  const [lectureLinks, setLectureLinks] = useState([]); // Filtered data

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Handle dropdown changes
  const handleChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  // Fetch ALL lecture links (batch-level)
  const fetchAllLectureLinks = async () => {
    if (!studentId) {
      setError("Student ID not found.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await axiosInstance.get("/getLectureLinksByStudentId", {
        params: {
          studentId,
          share_to_student: true,
        },
      });

      const links =
        Array.isArray(res.data) ? res.data : res.data?.data || [];

      setAllLinks(links); // Store full list
      setLectureLinks(links); // Initially show all
    } catch (err) {
      console.error("Error fetching lecture links:", err);
      setError("Failed to fetch lecture links.");
      setAllLinks([]);
      setLectureLinks([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch once on mount
  useEffect(() => {
    fetchAllLectureLinks();
  }, [studentId]);

  // Apply filters locally
  useEffect(() => {
    let filtered = [...allLinks];

    if (filters.sessions)
      filtered = filtered.filter(
        (item) => item.sessions === filters.sessions
      );

    if (filters.report_type)
      filtered = filtered.filter(
        (item) => item.report_type === filters.report_type
      );

    setLectureLinks(filtered);
  }, [filters, allLinks]);

  // Table columns
  const columns = [
    { field: "name", headerName: "Title", flex: 2 },

    {
      field: "presentation_recording_link",
      headerName: "Presentation Recording",
      flex: 1,
      renderCell: (params) =>
        params.value ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            Presentation
          </a>
        ) : (
          "—"
        ),
    },
    {
      field: "session_recording_link",
      headerName: "Session Recording",
      flex: 1,
      renderCell: (params) =>
        params.value ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            Session
          </a>
        ) : (
          "—"
        ),
    },
    {
      field: "rebuttal_report_template_link",
      headerName: "Rebuttal Report Template",
      flex: 1.5,
      renderCell: (params) =>
        params.value ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            Rebuttal Report
          </a>
        ) : (
          "—"
        ),
    },
    {
      field: "report_file_template_link",
      headerName: "Report Template",
      flex: 1.5,
      renderCell: (params) =>
        params.value ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            Report
          </a>
        ) : (
          "—"
        ),
    },
    {
      field: "other_file_tempate_link",
      headerName: "Other File Template",
      flex: 1.5,
      renderCell: (params) =>
        params.value ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            Other
          </a>
        ) : (
          "—"
        ),
    },
  ];

  return (
    <div className="datatable">
      <h2 className="datatableTitle">Lecture Resources</h2>

      {/* Filters */}
      <div className="filters">
        <select
          name="sessions"
          value={filters.sessions}
          onChange={handleChange}
          className="filterSelect"
        >
          <option value="">--Select Session--</option>
          <option value="Session 1">Session 1</option>
          <option value="Session 2">Session 2</option>
          <option value="Session 3">Session 3</option>
        </select>

        <select
          name="report_type"
          value={filters.report_type}
          onChange={handleChange}
          className="filterSelect"
        >
          <option value="">--Select Report Type--</option>
          <option value="ProjectProposal">Project Proposal</option>
          <option value="Phase1">Phase 1</option>
          <option value="Phase2">Phase 2</option>
          <option value="Phase3">Phase 3</option>
        </select>
      </div>

      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}

      {!loading && lectureLinks.length === 0 && (
        <p>No lecture resources found.</p>
      )}

      {/* DataGrid Table */}
      {lectureLinks.length > 0 && (
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={lectureLinks}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            disableSelectionOnClick
            autoHeight
          />
        </div>
      )}
    </div>
  );
};
